import { TellescopeModelFromName, useTellescopeQuery } from "@tellescope/tanstack-query";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { FileText } from "lucide-react";
import {
  CallOrVoicemailWrapper,
  SMSContextCard,
  EmailContextCard,
  EditableFormContextCard,
  OtherFormsContextCard,
  EventContextCard,
  PaymentsContextCard,
} from "./context-cards";

export interface TicketContextProps {
  ticketId: string;
  ticket?: TellescopeModelFromName<"tickets">;
}

export const TicketContext = ({ ticketId, ticket: providedTicket }: TicketContextProps) => {
  const { t } = useTranslation("tickets");
  const ticketQuery = useTellescopeQuery({
    model: "tickets",
    method: "getOne",
    request: ticketId,
    enabled: !!ticketId && !providedTicket,
  });

  const ticket = ticketQuery.data;

  const hasContext = useMemo<boolean>(() => {
    // TODO: implement commented out context items once we have designs

    // if (ticket?.contextEnduserFields?.length) return true;
    if (ticket?.phoneCallId) return true;
    if (ticket?.smsId) return true;
    if (ticket?.emailId) return true;
    // if (ticket?.carePlanId) return true;
    if (ticket?.formResponseIds?.length) return true;
    if (ticket?.contextFormIds?.length) return true;
    if (ticket?.purchaseId) return true;
    // if (ticket?.observationId) return true;
    // if (ticket?.databaseRecordId) return true;
    // if (ticket?.orderId) return true;
    // if (ticket?.triggerFileId) return true;
    // if (ticket?.contextContentIds?.length) return true;
    if (ticket?.calendarEventId) return true;

    return false;
  }, [
    ticket?.calendarEventId,
    // ticket?.carePlanId,
    // ticket?.contextContentIds?.length,
    // ticket?.contextEnduserFields?.length,
    ticket?.contextFormIds?.length,
    // ticket?.databaseRecordId,
    ticket?.emailId,
    ticket?.formResponseIds?.length,
    // ticket?.observationId,
    // ticket?.orderId,
    ticket?.phoneCallId,
    ticket?.purchaseId,
    ticket?.smsId,
    // ticket?.triggerFileId,
  ]);

  if (!hasContext) {
    return (
      <div className="text-xs text-muted-foreground flex gap-1 items-center">
        <FileText className="w-3 h-3 text-muted-foreground shrink-0" />
        <p>{t("No context")}</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {ticket?.phoneCallId && <CallOrVoicemailWrapper phoneCallId={ticket.phoneCallId} />}
      {ticket?.smsId && <SMSContextCard smsId={ticket.smsId} />}
      {ticket?.emailId && <EmailContextCard emailId={ticket.emailId} />}
      {!!ticket?.formResponseIds?.length &&
        ticket.formResponseIds.map((formResponseId) => (
          <EditableFormContextCard key={formResponseId} formResponseId={formResponseId} />
        ))}
      {ticket?.contextFormIds && ticket.contextFormIds.length > 0 && (
        <OtherFormsContextCard ticketId={ticketId} formIds={ticket.contextFormIds} />
      )}
      {ticket?.calendarEventId && <EventContextCard calendarEventId={ticket.calendarEventId} />}
      {ticket?.purchaseId && <PaymentsContextCard purchaseId={ticket.purchaseId} />}
    </div>
  );
};
